import {
	Button, Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay, useDisclosure, FormControl, FormLabel, Input, Select, Stack
} from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'
import useForm from 'hooks/useForm/useForm'
import { isoToDateTimeLocal } from 'utlis/timeUtils'

export const WorkingHourModal = (props) => {
	const {updateWorkingHours, mode, workingHour, users} = props
	
	// const values = props

	const [ values, setValues ] = useState({ ...workingHour, ...(mode === 'new' ? {  _id: undefined, identify: undefined, user_id: undefined, user: undefined } : {}) })
	// const [ newIdentify, setNewIdentify ] = useState(values.identify)
	const twins = {
		time_driving_to_work_closed: 'time_work_opened',
		time_work_opened: 'time_driving_to_work_closed',
		time_work_closed: 'time_driving_from_work_opened',
		time_driving_from_work_opened: 'time_work_closed'
	}


	const handleChange = (e) => {
		const value = e.target.value
		const twinObject = twins[e.target.name] ? { [twins[e.target.name]]: value } : {}
		console.log(e.target.name, value, twinObject)
        setValues({
            ...values,
            [e.target.name]: value,
			...(twins[e.target.name] ? {[twins[e.target.name]]: value} : {})
        })
	}

	useEffect(() => {
		setValues(prev => ({ ...prev, ...workingHour, ...(mode === 'new' ? { _id: undefined, identify: undefined, user_id: undefined, user: undefined } : {}) }))
	}, [workingHour])

    const {isOpen, onOpen, onClose} = useDisclosure()
	const saveWorkingHour = () => {
		// update only time* fields
		try{
			updateWorkingHours(values._id, {
				...(mode === 'new' ? { identify: values.identify, counting_id: values.counting_id } : {}),
				time_driving_to_work_opened: values.time_driving_to_work_opened,
				time_driving_from_work_closed: values.time_driving_from_work_closed,
				time_work_opened: values.time_work_opened,
				time_work_closed: values.time_work_closed,
				time_driving_to_work_closed: values.time_driving_to_work_closed,
				time_driving_from_work_opened: values.time_driving_from_work_opened,
			})
		} catch (e) {
			console.log('saveWorkingHour', 'error', e)
		}

		onClose()
	}

	// useEffect(() => {
	// 	console.log('workingHours', workingHours)
	// 	clearValues()
	// }, [workingHours])

	// id={workingHour._id}
	// 										userTz={workingHour.user?.identify}
	// 										name={`${workingHour.user?.name} ${workingHour.user?.last_name}`}
	// 										date={workingHour.created_at}
	// 										timeDrivingStart={workingHour.time_driving_to_work_opened}
	// 										timeWorkingStart={workingHour.time_work_opened}
	// 										timeWorkingClosed={workingHour.time_work_closed}
	// 										timeDrivingClosed={workingHour.time_driving_from_work_closed}
	// 										timeDrivingFromWorkStart={workingHour.time_driving_from_work_opened}
	// 										timeDrivingToWorkClosed={workingHour.time_driving_to_work_closed}
	
	return (
		<>
			{/* <WorkingHourButton  mode={ mode ?? 'edit'} onOpen={onOpen}/> */}
			<Button mr={2} size='sm' colorScheme={mode === 'new' ? 'green' : 'blue'} onClick={onOpen}>
				{mode ? String(mode).charAt(0).toUpperCase() + String(mode).slice(1): 'Edit'}
			</Button>
			<Modal isOpen={isOpen} onClose={onClose}>
				<ModalOverlay/>
				<ModalContent>
					<ModalHeader></ModalHeader>
					<ModalCloseButton/>
					<ModalBody>

						
								<FormControl>
									<FormLabel>TZ</FormLabel>
									<Input name='identify' value={values.identify} onChange={handleChange} isDisabled={mode !== 'new'} />
								</FormControl>

								<FormControl>
									<FormLabel>Name</FormLabel>
									{!users ? (
										<Input name='name' value={values.user ? `${values.user.name} ${values.user.last_name}` : ''} isDisabled={true} />
									) : (
										<Select name='identify' value={values.identify} onChange={handleChange} placeholder='Select user' isDisabled={mode !== 'new'}>
											{users.map(user => (
												<option key={user._id} value={user.identify}>{user.name} {user.last_name} ({user.identify})</option>
											))}
										</Select>
									)}
								</FormControl>

								<FormControl>
									<FormLabel>Driving To Work Start</FormLabel>
									<Input type='datetime-local' name='time_driving_to_work_opened' value={isoToDateTimeLocal(values.time_driving_to_work_opened)} onChange={handleChange} />
								</FormControl>
								<FormControl>
									<FormLabel>Driving To Work Finish</FormLabel>
									<Input type='datetime-local' name='time_driving_to_work_closed' value={isoToDateTimeLocal(values.time_driving_to_work_closed)} onChange={handleChange} />
								</FormControl>
								<FormControl>
									<FormLabel>Working Start</FormLabel>
									<Input type='datetime-local' name='time_work_opened' value={isoToDateTimeLocal(values.time_work_opened)} onChange={handleChange} />
								</FormControl>

								<FormControl>
									<FormLabel>Working Close</FormLabel>
									<Input type='datetime-local' name='time_work_closed' value={isoToDateTimeLocal(values.time_work_closed)} onChange={handleChange} />
								</FormControl>

								<FormControl>
									<FormLabel>Driving From Work Start</FormLabel>
									<Input type='datetime-local' name='time_driving_from_work_opened' value={isoToDateTimeLocal(values.time_driving_from_work_opened)} onChange={handleChange} />
								</FormControl>

								<FormControl>
									<FormLabel>Driving Close</FormLabel>
									<Input type='datetime-local' name='time_driving_from_work_closed' value={isoToDateTimeLocal(values.time_driving_from_work_closed)} onChange={handleChange} />
								</FormControl>
							
					</ModalBody>
					<ModalFooter>
						<Button onClick={()=>saveWorkingHour()} colorScheme='blue' mr={3}>
							Save
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	)
}